<p class="footer-socials__title">{{ 'core.footer.follow' | translate }}</p>

<div class="footer-socials__icons">
    @for (link of links(); track link.id) {
        <a class="footer-socials__icon"
           [class]="link.customClass"
           [href]="link.href"
           [target]="link.target"
           [attr.rel]="link.rel"
           [attr.aria-label]="link.ariaLabel"
        >
            @if (link.image?.url) {
                <cms-image class="footer-socials__img" [media]="link.image" [fallbackAlt]="''"/>
            } @else {
                <app-brand-icon name="asterisk"/>
            }
        </a>
    }
</div>
